module.exports = __webpack_public_path__ + "static/media/input_output.d70b0f60.png";